import { z } from 'zod'

export const profileFormSchema = z.object({
  first_name: z.string().min(1, 'profile.errors.first_name_required').max(100),
  last_name: z.string().min(1, 'profile.errors.last_name_required').max(100),
  language: z.enum(['fr', 'en', 'ar', 'es']),
  is_profile_public: z.boolean(),
})

export const usernameSchema = z.object({
  username: z
    .string()
    .min(3, 'profile.errors.username_min')
    .max(30, 'profile.errors.username_max')
    .regex(/^\w+$/, 'profile.errors.username_pattern'),
})

export type ProfileFormData = z.infer<typeof profileFormSchema>
export type UsernameFormData = z.infer<typeof usernameSchema>

export type UpdateProfilePayload = ProfileFormData
